import { useState, type FormEvent } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { api } from '../api/client'
import { useAuth } from '../auth/AuthContext'
import { PageShell } from '../components/BrandChrome'
import { Alert, Button, Card, Input, Label, Subtitle, Title } from '../components/ui'
import { errorMessage } from '../lib/format'

export function LoginPage() {
  const navigate = useNavigate()
  const { refresh } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await api.login(email.trim(), password)
      const me = await refresh()
      if (!me) {
        setError('Signed in but session could not be loaded.')
        return
      }
      if (!me.mfa_enrolled) {
        navigate('/mfa/setup', { replace: true })
        return
      }
      navigate('/drops', { replace: true })
    } catch (err) {
      setError(errorMessage(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <PageShell homeTo="/login">
      <Card className="mx-auto max-w-md">
        <Title>Sign in</Title>
        <Subtitle>Creator access for SuretySwap secure drops.</Subtitle>
        <form className="space-y-4" onSubmit={onSubmit}>
          {error ? <Alert>{error}</Alert> : null}
          <div>
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              name="email"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(ev) => setEmail(ev.target.value)}
            />
          </div>
          <div>
            <div className="mb-1 flex items-center justify-between gap-2">
              <Label htmlFor="password">Password</Label>
              <Link to="/forgot-password" className="text-sm text-slate-600 hover:text-slate-900">
                Forgot password?
              </Link>
            </div>
            <Input
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(ev) => setPassword(ev.target.value)}
            />
          </div>
          <Button type="submit" disabled={busy} className="w-full">
            {busy ? 'Signing in…' : 'Sign in'}
          </Button>
        </form>
        <p className="mt-4 text-center text-sm text-slate-600">
          Need an account? <Link to="/register">Register</Link>
          {' · '}
          <Link to="/mfa/recover">Recover MFA</Link>
        </p>
      </Card>
    </PageShell>
  )
}
